module.exports = __webpack_public_path__ + "static/media/rafflesmarina_3.441fb5f4.jpg";